<template>
  <div class="w-90">
    <b-card bg-variant="light">
      <h1 id="jump-to-header">{{heading || generated_heading}}</h1>
      <b-tabs
        active-nav-item-class="font-weight-bold text-uppercase text-warning"
        active-tab-class="font-weight-bold text-success"
        content-class="mt-3"
        lazy
      >
        <b-tab title="Settings" active>
          <product-listing-update 
            :id="id"
            @gotAttrs="assignAttrs"
          ></product-listing-update>
        </b-tab>
        <b-tab title="Information">
          <polymorphic-reference-index
            :filtering="filtering_reference"
            :ams_template="ams_template_reference"
          ></polymorphic-reference-index>
        </b-tab>
        <b-tab title="Assets">
          <product-item-index
            :filtering="filtering"
            :ams_template="ams_template"
          ></product-item-index>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import ProductListingUpdate from './ProductListingUpdate.vue'
import ProductItemIndex from './ProductItemIndex.vue'
import PolymorphicReferenceIndex from './PolymorphicReferenceIndex.vue'

export default {
  components: {
    ProductListingUpdate,
    ProductItemIndex,
    PolymorphicReferenceIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      generated_heading: undefined,
      filtering: {
        product_listing_ids: this.id
      },
      /*
      ProductItem(id: uuid, collection_id: uuid, product_listing_id: uuid, 
      description: text, serial_number: integer, 
      purchased_price_cents: integer, 
      estimated_min_price_cents: integer, estimated_max_price_cents: integer, 
      authenticated_min_price_cents: integer, 
      authenticated_max_price_cents: integer, 
      asking_price_cents: integer, 
      sold_price_cents: integer, 
      estimated_quality: integer, 
      authenticated_quality: integer, 
      at_status: integer, 
      collected_at: datetime, prepared_at: datetime, delivered_at: datetime, received_at: datetime, 
      created_at: datetime, updated_at: datetime)
      */
      ams_template: {
        type: 'product-items',
        description: undefined,
        attributes: {
          'product-listing-id': this.id,
          'storage-space-id': undefined,
          'purchased-price-cents': 0,
          'estimated-min-price-cents': 0,
          'estimated-max-price-cents': 0,
          'authenticated-min-price-cents': 0,
          'authenticated-max-price-cents': 0,
          'asking-price-cents': 0,
          'estimated-quality': 9000,
          'authenticated-quality': 0
        }
      },
      filtering_reference: {
        reference_to_type: 'ProductListing',
        reference_to_id: this.id
      },
      ams_template_reference: {
        type: 'polymorphic-references',
        descrition: undefined,
        attributes: {
          'reference-to-type': "ProductListing",
          'reference-to-id': this.id
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.generated_heading = description
      this.attrs = Object.assign( {}, attrs)
      this.ams_template.description = description + ' # ' + attrs['edition']
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>